import { gql as o } from "@apollo/client";
const n = o`
  fragment PageInfoCommon on CommonPageInfo {
    hasNextPage
    hasPreviousPage
  }
`, t = o`
  fragment PageInfoLite on LitePageInfo {
    ...PageInfoCommon
    totalCount
  }
  ${n}
`, a = o`
  fragment PageInfoSkipTotal on PageInfo {
    ...PageInfoCommon
    endCursor
    startCursor
  }
  ${n}
`, g = o`
  fragment PageInfo on PageInfo {
    ...PageInfoSkipTotal
    totalCount
  }

  ${a}
`;
export {
  g as PageInfoFragment,
  t as PageInfoLiteFragment,
  a as PageInfoSkipTotalFragment
};
//# sourceMappingURL=pageInfo.js.map
